import * as m from "./../../dist/es2015/map.js";
export const am5map = m;